"use client"

import { useEffect, useRef } from "react"
import { useSearchParams } from "next/navigation"

import { useActionLink } from "@/hooks/api/action-links"
import {
  DOCUMENT_EDITOR_DIALOG_PARAM,
  useDocumentEditorDialog,
} from "@/components/document-editor/use-document-editor-dialog"

export function DocumentEditorDialogRestorer() {
  const searchParams = useSearchParams()
  const openDocumentEditorDialog = useDocumentEditorDialog()

  const actionLinkId = searchParams.get("dialog") === DOCUMENT_EDITOR_DIALOG_PARAM ? searchParams.get("id") : null
  // A dialog opened after mount already has an entry; only restore deep links on initial load.
  const hasHandledInitialDialog = useRef(!actionLinkId)
  const { data: actionLink } = useActionLink(actionLinkId ?? "", { enabled: !!actionLinkId })
  const deliverableId = actionLink?.deliverable_id
  const filename =
    typeof actionLink?.properties?.filename === "string" ? actionLink.properties.filename : "document.pdf"

  useEffect(() => {
    if (hasHandledInitialDialog.current || !actionLinkId || !deliverableId) return

    hasHandledInitialDialog.current = true
    openDocumentEditorDialog({ deliverableId, actionLinkId, title: filename })
  }, [actionLinkId, deliverableId, filename, openDocumentEditorDialog])

  return null
}
